import Profile from '../../components/Profile';

export default function FacilitatorProfile() {
  return <Profile role="facilitator" />;
}